"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
exports.TagRenderer = (0, react_1.memo)(({ tag }) => {
    return ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: tag, size: "small", variant: "outlined", sx: {
            margin: "2px",
            fontSize: "0.75rem",
            borderRadius: "4px",
            borderColor: "primary.main",
            color: "primary.main",
        } }));
});
exports.TagRenderer.displayName = "TagRenderer";
